{"buildRevision":"1dcc2d81535ca3b866b570c1c63af2d9ef5125e5","buildTimestamp":"2026-09-26T15:33:33.073Z","dirty":true,"version":"5.6.10"}